import * as ng from 'angular';
import {googleAPI} from '../../../third/googleAPI';
import {appContext} from '../../../app.context';
import {StorageService} from '../../../services/storage.service';
import {UserService} from '../../../services/user.service';
import {ArchiSmallServices} from '../../../services/archismall.service';
import {ValidationService} from '../../../services/validation.service';
import {CountryCodesService} from '../../../services/data/country-codes.service';
import {AlertService} from '../../../services/ui/alert.service';
import {VATService} from '../../../services/data/vat.service';


export const UserSettingsProfiloComponent = {
  template: require('./gestione-profilo.html'),
  controller: class UserSettingsProfiloController {
    static $inject: string[] = [
      '$rootScope',
      '$scope',
      '$state',
      'ArchiSmallServices',
      'store',
      '$uibModal',
      'configuration',
      '$sce',
      '$parse',
      'ValidationService',
      'StorageService',
      'UserService',
      'AlertService',
      'CountryCodesService',
      'VATService'
    ];

    private countriesCodeValues: Record<string, string>;

    constructor(
      private $rootScope: any,
      private $scope: any,
      private $state: ng.ui.IStateService,
      private ArchiSmallServices: ArchiSmallServices,
      private store: ng.a0.storage.IStoreService,
      private $uibModal: ng.ui.bootstrap.IModalService,
      private configuration: any, // todo specificare il tipo
      private $sce: ng.ISCEService,
      private $parse: ng.IParseService,
      private ValidationService: ValidationService,
      private StorageService: StorageService,
      private UserService: UserService,
      private alertService: AlertService,
      countryCodesService: CountryCodesService,
      private vatService: VATService
    ) {

      $scope.ivaItems = this.vatService.getItems();
      $scope.tooltips = {
        'header': `Completa, aggiorna o modificare le informazioni fornite durante la registrazione.\n
                    La Ragione Sociale, la Partita IVA e il Codice Fiscale non possono essere modificati\n
                    (in caso di errore contatta l'Assistenza). Le informazioni appariranno nella Fattura\n
                    Elettronica che trasmetti con ArchiSMALL (es: Iscrizione REA, Albo Professionale, ecc).`,
        'disdici': `Vuoi disdire il tuo abbonamento?`,
        'securityQuestion': `Scegli una "Domanda di Sicurezza". Queste domande servono a verificare la tua identità o ad aiutarti a reimpostare la password.`,
        'customSecurityQuestion': `Crea la tua domanda di sicurezza personalizzata.`,
        'securityAnswer': `Scegli una "Risposta" alla tua "Domanda di Sicurezza". Servirà a verificare la tua identità o ad aiutarti a reimpostare la password nel caso la dimenticassi.`,
        'indirizzoPEC': `Facoltativo: inserisci l'indirizzo PEC (posta elettronica certificata) che usi per la tua azienda.`
      };

      $scope.CodiceDestinatarioType = new RegExp('^[A-Z0-9]{7}$');
      $scope.validCodiceDestinatario = true;
      $scope.pageHeader = 'Impostazioni Utente';
      $scope.user = $scope.$parent.$resolve.user;
      store.set('user', $scope.user);
      $scope.isAdmin = () => {
        return $scope.user.isAdmin;
      };
      if (!$scope.user) {
        $state.go('login');
      } else {

        $scope.identityCardMissing = $scope.user.organizationData.contactPerson.identityCardFile === '';

        $scope.securityQuestions = [
          `Domanda personalizzata`,
          `Qual è la tua squadra del cuore?`,
          `Qual è il nome del tuo cane?`,
          `Qual è il nome del tuo gatto?`,
          `Qual è la tua serie TV preferita?`,
          `Gruppo musicale preferito?`,
          `Qual è il cognome da nubile di tua madre/nonna?`,
          `Qual è il nome della tua bisnonna?`,
          `Qual è il nome del/della tua maestra/o o della scuola?`,
          `Qual è il nome del tuo primo animale domestico?`,
          `Qual è il tuo cibo preferito?`,
          `Quale film non ti stancheresti mai di vedere?`,
          `Qual è il tuo libro preferito?`,
          `Qual è il nome del tuo eroe da bambino?`
        ];

        if ($scope.user.organizationData.responsabileConservazione != null || $scope.user.organizationData.responsabileConservazione != undefined) {
          $scope.useResponConserv = $scope.user.useResponConserv;
        }

        $scope.trustAsHtml = (value) => {
          return $sce.trustAsHtml(value);
        };

        let init = () => {
          if ($rootScope.user !== undefined) {
            if ($rootScope.user.accountData.userType === 1) {
              $state.go('usersettings.gestione-profilo-lp');
              return;
            }
          } else {
            setTimeout(init, 1000);
          }
        };

        init();
        $scope.checkPassword = true;
        $scope.validEmail = true;
        $scope.validPEC = true;
        $scope.validNumbers = /^\d+$/;
        $scope.validateEmail = (email) => {
          if (email === null || email === '') {
            $scope.validEmail = true;
            return;
          }

          ArchiSmallServices.validateEmail(email)
            .then((response) => {
              $scope.validEmail = response;
            }, (error) => {
              this.alertService.alert('error', error);
            });
        };
        $scope.validatePEC = (email) => {
          if (email === null || email === '') {
            $scope.validPEC = true;
            return;
          }

          ArchiSmallServices.validateEmail(email)
            .then((response) => {
              $scope.validPEC = response;
            }, (error) => {
              this.alertService.alert('error', error);
            });
        };

        $scope.dpOpened = {
          periodStart: false,
          periodEnd: false,
          birthDate: false,
          dataIscrizioneAlbo: false
        };
        $scope.openDP = ($event, opened) => {
          $event.preventDefault();
          $event.stopPropagation();
          $scope.dpOpened[opened] = true;
        };
        $scope.autoOpen = ($event, opened) => {

          // tslint:disable-next-line:no-string-literal
          if (appContext.userBrowser['isIE']) {
            return;
          }
          $event.preventDefault();
          $event.stopPropagation();
          $scope.dpOpened[opened] = true;
        };

        $scope.openPasswordModal = (size) => {

          let changePasswordModal = $uibModal.open({
            animation: true,
            component: 'changePasswordComponent',
            size: size,
            windowClass: 'center-modal',
            resolve: {}
          });
        };

        $scope.openConfermaModal = (size) => {
          let ConfermaModal = $uibModal.open({
            animation: true,
            component: 'confermaComponent',
            size: size,
            windowClass: 'center-modal',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              user: () => {
                return $scope.user;
              }
            }
          });
        };

        $scope.openChangePersonalFilesModal = (size) => {

          let ChangePersonalFilesModal = $uibModal.open({
            animation: true,
            component: 'changePersonalFilesComponent',
            size: size,
            windowClass: 'center-modal',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              user: () => {
                return $scope.user;
              }
            }
          });

          ChangePersonalFilesModal.result.then((data) => {
            if (data.user !== undefined) {
              $scope.user = data.user;
              $scope.updatePersonalFiles(data);
            }

            if (data.requiredFieldsMissing !== undefined) {
              $scope.identityCardMissing = data.requiredFieldsMissing;
            }
          });
        };

        $scope.updatePersonalFiles = (data) => {
          $scope.files = {};
          if (data.changed.fiscalCode) {
            $scope.files.fiscalCode = {
              'fileName': $scope.user.organizationData.contactPerson.fiscalCodeFile,
              'fileId': $scope.user.organizationData.contactPerson.fiscalCodeFileId
            };
          }
          if (data.changed.identityCard) {
            $scope.files.identityCard = {
              'fileName': $scope.user.organizationData.contactPerson.identityCardFile,
              'fileId': $scope.user.organizationData.contactPerson.identityCardFileId
            };
          }
          if (data.changed.businessProfile) {
            $scope.files.businessProfile = {
              'fileName': $scope.user.organizationData.contactPerson.businessProfileFile,
              'fileId': $scope.user.organizationData.contactPerson.businessProfileFileId
            };
          }

          let promise = UserService.updatePersonalFiles($scope.files)
            .then((response) => {
              $scope.user = response;
              store.set('user', $scope.user);
            }, (error) => {
              this.alertService.alert('error', error);
            });

          return promise;
        };

        $scope.refreshSedeStates = () => {
          let country = $scope.user.organizationData.codicePaese;
          ArchiSmallServices.getTypeaheadValues('state', `country=${country}`)
            .then((response) => {
              $scope.sedeStates = response;
            }, (error) => {
              this.alertService.alert('error', error);
            });
        };
        $scope.refreshStabileStates = () => {
          let country = $scope.user.organizationData.stabileOrganizzazione.codicePaese;
          ArchiSmallServices.getTypeaheadValues('state', `country=${country}`)
            .then((response) => {
              $scope.stabileStates = response;
            }, (error) => {
              this.alertService.alert('error', error);
            });
        };
        $scope.refreshStateCodes = () => {
          let country = 'IT';
          ArchiSmallServices.getTypeaheadValues('stateCodes', `country=${country}`)
            .then((response) => {
              $scope.stateCodes = response;
            }, (error) => {
              this.alertService.alert('error', error);
            });
        };
        $scope.refreshCities = () => {
          let country = $scope.user.organizationData.codicePaese;
          let state = $scope.user.organizationData.province;
          ArchiSmallServices.getTypeaheadValues('municipality', `country=${country}&state=${state}`)
            .then((response) => {
              $scope.cities = response;
            }, (error) => {
              this.alertService.alert('error', error);
            });
        };
        $scope.refreshStabileCities = () => {
          let country = $scope.user.organizationData.stabileOrganizzazione.codicePaese;
          let state = $scope.user.organizationData.stabileOrganizzazione.province;
          ArchiSmallServices.getTypeaheadValues('municipality', `country=${country}&state=${state}`)
            .then((response) => {
              $scope.citiesStabile = response;
            }, (error) => {
              this.alertService.alert('error', error);
            });
        };
        $scope.getCAP = () => {
          ArchiSmallServices.getTypeaheadValues('cap', 'state=' + $scope.user.organizationData.province + '&city=' + $scope.user.organizationData.city)
            .then((response) => {
              if (response[0] !== '') {
                $scope.user.organizationData.CAP = response[0];
              }
            }, (error) => {
              this.alertService.alert('error', error);
            });
        };
        $scope.getStabileCAP = () => {
          ArchiSmallServices.getTypeaheadValues('cap', 'state=' + $scope.user.organizationData.stabileOrganizzazione.province + '&city=' + $scope.user.organizationData.stabileOrganizzazione.city)
            .then((response) => {
              if (response[0] !== '') {
                $scope.user.organizationData.stabileOrganizzazione.CAP = response[0];
              }
            }, (error) => {
              this.alertService.alert('error', error);
            });
        };
        $scope.refreshBirthCountries = () => {
          ArchiSmallServices.getTypeaheadValues('country')
            .then((response) => {
              $scope.birthCountries = response;
            }, (error) => {
              this.alertService.alert('error', error);
            });
        };
        $scope.refreshBirthStates = () => {
          let country = $scope.user.organizationData.contactPerson.birthCountry === '' ? 'Italy' : $scope.user.organizationData.contactPerson.birthCountry;
          ArchiSmallServices.getTypeaheadValues('state', 'country=' + country)
            .then((response) => {
              $scope.birthStates = response;
            }, (error) => {
              this.alertService.alert('error', error);
            });
        };
        $scope.refreshBirthCities = () => {
          let country = $scope.user.organizationData.contactPerson.birthCountry;
          let state = $scope.user.organizationData.contactPerson.birthProvince;
          ArchiSmallServices.getTypeaheadValues('municipality', 'country=' + country + '&state=' + state)
            .then((response) => {
              $scope.birthCities = response;
            }, (error) => {
              this.alertService.alert('error', error);
            });
        };
        $scope.sedeStates = [];
        $scope.cities = [];
        $scope.birthCountries = [];
        $scope.birthStates = [];
        $scope.birthCities = [];
        $scope.callTypeaheadFunctions = () => {
          $scope.refreshSedeStates();
          $scope.refreshStabileStates();
          $scope.refreshStateCodes();
          $scope.refreshBirthStates();
          $scope.refreshBirthCountries();
          $scope.refreshCities();
          $scope.refreshStabileCities();
        };
        $scope.regimeFiscaleValues = {
          'RF01': 'Ordinario',
          'RF02': 'Contribuenti minimi (art.1, c.96-117, L. 244/07)',
          'RF04': 'Agricoltura e attività connesse e pesca (artt.34 e 34-bis, DPR 633/72)',
          'RF05': 'Vendita sali e tabacchi (art.74, c.1, DPR. 633/72)',
          'RF06': 'Commercio fiammiferi (art.74, c.1, DPR 633/72)',
          'RF07': 'Editoria (art.74, c.1, DPR 633/72)',
          'RF08': 'Gestione servizi telefonia pubblica (art.74, c.1, DPR 633/72)',
          'RF09': 'Rivendita documenti di trasporto pubblico e di sosta (art.74, c.1, DPR 633/72)',
          'RF10': 'Intrattenimenti, giochi e altre attività di cui alla tariffa allegata al DPR 640/72 (art.74, c.6, DPR 633/72)',
          'RF11': 'Agenzie viaggi e turismo (art.74-ter, DPR 633/72',
          'RF12': 'Agriturismo (art.5, c.2, L. 413/91) ',
          'RF13': 'Vendite a domicilio (art.25-bis, c.6, DPR 600/73) ',
          'RF14': 'Rivendita beni usati, oggetti d’arte, d’antiquariato o da collezione (art.36, DL 41/95)',
          'RF15': 'Agenzie di vendite all’asta di oggetti d’arte, antiquariato o da collezione (art.40-bis, DL 41/95) ',
          'RF16': 'IVA per cassa P.A. (art.6, c.5, DPR 633/72) ',
          'RF17': 'IVA per cassa (art. 32-bis, DL 83/2012) ',
          'RF18': 'Altro',
          'RF19': 'Regime forfettario (art.1, c.54-89, L. 190/2014)',
          'RF20': 'Regime transfrontaliero di Franchigia IVA (Direttiva UE 2020/285)'
        };
        $scope.socioUnicoValues = {
          'SU': 'socio unico',
          'SM': 'più soci',
        };
        $scope.statoLiquidazioneValues = {
          'LS': 'in liquidazione',
          'LN': 'non in liquidazione'
        };
        this.countriesCodeValues = countryCodesService.getCountryCodes();

        $scope.phoneType = new RegExp('^[\u0000-\u007F]{5,12}$');
        $scope.PIVAType = new RegExp('^[A-Z0-9]{1,28}$');
        $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{11,16}$');
        $scope.CAPType = new RegExp('^[0-9]{5}$');
        $scope.String20Type = new RegExp('^[\u0000-\u007F]{1,20}$');
        $scope.TitoloType = new RegExp('^[\u0000-\u007F]{2,10}$');
        $scope.CodEORIType = new RegExp('^.{13,17}$');
        $scope.String60LatinType = new RegExp('^[\u0000-\u00FF]{1,60}$');
        $scope.ProvinciaType = new RegExp('^[A-Z]{2}$');
        $scope.String60Type = new RegExp('^[\u0000-\u007F]{1,60}$');
        $scope.String80LatinType = new RegExp('^[\u0000-\u00FF]{1,80}$');
        $scope.String60LatinType = new RegExp('^[\u0000-\u00FF]{1,60}$');
        $scope.NumeroCivicoType = new RegExp('^[\u0000-\u007F]{1,8}$');

        $scope.openUploadLogoModal = (size) => {

          let modalInstance = $uibModal.open({
            animation: true,
            component: 'uploadLogoModalComponent',
            controllerAs: 'vm',
            size: size,
            windowClass: 'center-modal',
            resolve: {
              user: $scope.user
            }
          });

          modalInstance.result.then((user) => {
            if (user !== undefined) {
              $scope.user = user;
              store.set('user', user);
            }
          });
        };

        $scope.getCurrentYearDate = () => {
          if ($scope.user.organizationData.periodiDiEsercizioAnnoSolare) {
            let currentYear = (new Date()).getFullYear();
            let start = new Date(currentYear, 0, 1);
            let end = new Date(currentYear, 11, 31);
            $scope.user.organizationData.periodStart = start;
            $scope.user.organizationData.periodEnd = end;
          } else {
            $scope.user.organizationData.periodStart = '';
            $scope.user.organizationData.periodEnd = '';
          }
        };
        $rootScope.formsubmitted = false;
        $scope.emptyIfFieldChanged = (dependentModel1, dependentModel2, dependentModel3) => {
          $parse(dependentModel1).assign($scope, '');
          if (dependentModel2) {
            $parse(dependentModel2).assign($scope, '');
          }
          if (dependentModel3) {
            $parse(dependentModel3).assign($scope, '');
          }
        };
        $scope.emptyInput = () => {
          $scope.oldInputValue = $scope.user.accountData.securityAnswer;
          $scope.user.accountData.securityAnswer = '';
          $scope.user.accountData.securityAnswer = '';
        };
        $scope.fillInput = () => {
          if ($scope.user.accountData.securityAnswer === '') {
            $scope.user.accountData.securityAnswer = $scope.oldInputValue;
            $scope.user.accountData.securityAnswer = $scope.oldInputValue;
          }
        };

        let initUserVar = () => {
          $scope.user.organizationData.contactPerson.birthDate = $rootScope.formatDateValue($scope.user.organizationData.contactPerson.birthDate);
          if ($scope.user.organizationData.responsabileConservazione) {
            $scope.user.organizationData.responsabileConservazione.birthDate = $rootScope.formatDateValue($scope.user.organizationData.responsabileConservazione.birthDate);
          }
          ;
          $scope.user.organizationData.periodStart = $rootScope.formatDateValue($scope.user.organizationData.periodStart);
          $scope.user.organizationData.periodEnd = $rootScope.formatDateValue($scope.user.organizationData.periodEnd);
          if ($scope.user.organizationData.codiceDestinatario && $scope.user.organizationData.codiceDestinatario.substring(0, 1) === '*') {
            $scope.user.organizationData.codiceDestinatario = 'ACTKBBZ';
          }
          if ($scope.user.organizationData.alboProfessionale !== undefined && $scope.user.organizationData.alboProfessionale.dataIscrizioneAlbo && $scope.user.organizationData.alboProfessionale.dataIscrizioneAlbo !== '') {
            $scope.user.organizationData.alboProfessionale.dataIscrizioneAlbo = $rootScope.formatDateValue($scope.user.organizationData.alboProfessionale.dataIscrizioneAlbo);
          }

          $scope.callTypeaheadFunctions();
        };

        initUserVar();

        $scope.validateCodiceDestinatario = (path, value) => {

          if (value === null || value === '') {
            $scope.validCodiceDestinatario = true;
            return;
          }
          ValidationService.validateUserFieldUniqueness(path, value)
            .then((response) => {
              $scope.validCodiceDestinatario = response;
            }, (error) => {
              this.alertService.alert('error', error);
            });
        };

        $scope.startInputUpload = () => {
          $('#logo-upload').trigger('click');
        };

        $scope.inputUpload = (input) => {
          let file = input.files[0];
          let username = $scope.user.accountData.email;
          let dropzoneId = 'dropzone-logo';
          $scope.uploadFileOnGoogleStorage(file, username, dropzoneId);
        };

        let insertObject = (file, username, dropzoneId) => {
          let dropzoneStorageFolder = 'users/' + $scope.user.accountData.email + '/personal_files';
          ArchiSmallServices.validateGoogleAPIToken(googleAPI.getAccessToken())
            .then((response: any) => {
              googleAPI.insertObject(file, dropzoneId, dropzoneStorageFolder, username, $scope.uploadLogoFileOnGoogleStorageCallback);
              $rootScope.filesUploadedNumber++;
            }, (error) => {
              ArchiSmallServices.getGoogleAPIToken()
                .then((response: any) => {
                  googleAPI.setAccessToken(response.accessToken);
                  googleAPI.insertObject(file, dropzoneId, dropzoneStorageFolder, username, $scope.uploadLogoFileOnGoogleStorageCallback);
                  $rootScope.filesUploadedNumber++;
                }, (error) => {
                  this.alertService.alert('error', error);
                });
            });
        };

        $scope.uploadFileOnGoogleStorage = (file, username, dropzoneId) => {

          // user max upload size check
          if ((file.size / 1024 / 1024) > $scope.user.limits.maxFileSizeOnUploadMB) {
            this.alertService.alert('error', 'Il file ' + file.name + ' supera il limite di dimensione massimo consentito per l\'upload un singolo file (' + $scope.user.limits.maxFileSizeOnUploadMB + ' MB). Se desideri incrementare questo limite puoi contattare il supporto ArchiSMALL.');
            return;
          }

          // usage Percentage check XXX verificare questa fuzione per bug torta occupazione, presumo
          ArchiSmallServices.getStorageUsage()
            .then((response: any) => {
              $rootScope.storageUsage = response;

              if (response.subscriptionCancelled) {
                this.alertService.alert('error', 'You can\'t upload files, because your subscription is cancelled');
                return;
              }

              if ($rootScope.storageUsage.usagePercentage >= 100 && $rootScope.storageUsage.isBlockUser) {
                this.alertService.alert('error', 'Hai esaurito lo spazio a disposizione (' + $rootScope.storageUsage.availableSpace + '). Richiedei un incremento di spazio contattando il supporto ArchiSMALL.');
                return;
              }

              insertObject(file, username, dropzoneId);
            }, (error) => {
              this.alertService.alert('error', error);
            });
        };

        let getLogoBase64 = (logoStoragePath) => {
          StorageService.getBase64(logoStoragePath)
            .then((response) => {
              $scope.imagePreview = response.data;
            }, (error) => {
              this.alertService.alert('error', error);
            });
        };

        $scope.uploadLogoFileOnGoogleStorageCallback = (dropzoneId, res, filename) => {
          let icon = '';
          let extension = filename.split('.').pop().toLowerCase();
          let delete_icon = '<a ng-click="vm.deleteFile($event)"><i class="fa fa-trash-o fa-lg"></i></a>';

          switch (extension) {
            case 'jpg':
            case 'png':
              icon = $sce.trustAsHtml('<i class="fa fa-file-image-o fa-lg"></i>');
              break;
            default:
              icon = $sce.trustAsHtml('<i class="fa fa-file-o fa-lg"></i>');
          }

          $scope.user.organizationData.logoStoragePath = res.id.split('/')[0] + '/' + res.name;
          $scope.logoFilename = filename;
          $scope.updateLogo();
        };

        $scope.updateLogo = () => {
          let promise = UserService.updateLogo($scope.user)
            .then((user) => {
              $scope.user = user;
              store.set('user', $scope.user);

              if (!$scope.logoIsEmpty()) {
                getLogoBase64($scope.user.organizationData.logoStoragePath);
              }
              initUserVar();
            }, (error) => {
              this.alertService.alert('error', error);
            });

          return promise;
        };

        let removeLogo = () => {
          let promise = UserService.removeLogo($scope.user)
            .then((user) => {
              $scope.user = user;
              store.set('user', $scope.user);
              initUserVar();
            }, (error) => {
              this.alertService.alert('error', error);
            });
          return promise;
        };

        $scope.logoIsEmpty = () => {
          return $scope.user.organizationData.logoStoragePath === '' ||
            $scope.user.organizationData.logoStoragePath === undefined;
        };

        if (!$scope.logoIsEmpty()) {
          getLogoBase64($scope.user.organizationData.logoStoragePath);
        }

        $scope.deleteLogo = () => {
          removeLogo();
          $scope.deleteInputFile();
        };

        $scope.deleteInputFile = () => {
          let element = ng.element(document.querySelector('#logo-upload'));
          ng.element(element).val(null);
        };
        $scope.openUnsubscribeMessageModal = (size) => {

          let UnsubscribeMessageModal = $uibModal.open({
            animation: true,
            component: 'unsubscribeMessageModalComponent',
            size: size,
            windowClass: 'center-modal',
            backdrop: 'static',
            keyboard: false
          });
        };

        $scope.openUnsubscribeModal = (size) => {

          let UnsubscribeModal = $uibModal.open({
            animation: true,
            component: 'unsubscribeModalComponent',
            size: size,
            backdrop: 'static',
            keyboard: false,
            windowClass: 'center-modal'
          });
          UnsubscribeModal.result.then((response) => {
            if (response) {
              ArchiSmallServices.unsubscribe($scope.user)
                .then((response) => {
                  // riprendere info utente
                  ArchiSmallServices.getUser($rootScope.currentUser().sub)
                    .then((response) => {
                      $rootScope.user = response;
                      store.set('user', response);
                      $rootScope.verifyIfCancelSubscriptionRequestIsConfimed();
                    }, (error) => {
                      $rootScope.alert('error', error);
                    });
                }).catch((error) => {
                this.alertService.alert('error', error);
                $scope.cancel();
              });
            }
          });
        };
      }
    }
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/gestione-profilo/gestione-profilo.ts